import React from 'react'
import './content.scss'

export default function EmeraldContactFormSection() {
  return (
    <div className="home-contact-form cf">
      <div className="container">
        <div className="cf__block">
          <div className="cf__left">
            <h3 className="cf__title">Friendly service 24 hours a day, 7 days a week. </h3>
            <p className="cf__subtitle">Fill the form and we will contact you</p>

            <div className="cf__contact">
              <div className="cf__contact-block">
                <div className="cf__contact-block--icon">
                  <i className="fa-sharp fa-solid fa-comment-lines"></i>
                </div>
                <a href="#" className="cf__contact-block--link">
                  Live Chat
                </a>
              </div>
              <div className="cf__contact-block">
                <div className="cf__contact-block--icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <a href="#" className="cf__contact-block--link">
                  1-800-569-0570
                </a>
              </div>
            </div>
          </div>

          <div className="cf__right">
            <div className="cf__form-holder">
              <form className="cf__form">
                <div className="cf__form-top">
                  <div className="cf__form-block">
                    <input type="text" id="fname" name="fname" placeholder="Name" />
                  </div>
                  <div className="cf__form-block">
                    <input type="email" id="email" name="email" placeholder="Email" />
                  </div>
                </div>
                <div className="cf__form-body">
                  <div className="cf__form-block w-100">
                    <textarea placeholder="Message"></textarea>
                  </div>
                </div>
                <div className="cf__form-bottom">
                  <button className="cf__form-submit">
                    <i className="fa-sharp fa-solid fa-paper-plane"></i>SEND US A MESSAGE
                  </button>
                </div>
              </form>
              <small className="cf__form-small">
                By pressing the “Send” button, you confirm that you give the company your consent
                for processing your personal data. All e-mails and faxes will be answered within 1
                business day. Our website will be available 24/7. At any time you can browse
                products, place an order, track an order, view order history or utilize other
                features our website has to offer.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
